import { AdditionalProductViewSchema } from '@fsf/types';
import { _ } from '@ngx-translate/core';
import { z } from 'zod';

export const ADDITIONAL_PRODUCT_TYPES = [
  'fixed',
  'multiply',
  'multiply_reduced_one',
] as const;
export type AdditionalProductType = (typeof ADDITIONAL_PRODUCT_TYPES)[number];

export type AdditionalProduct = z.infer<typeof AdditionalProductViewSchema>;

export const StoreAdditionalProductSchema = z.object({
  title: z.string().min(1, { message: 'validation.required' }).max(255),
  description: z.string().nullable().optional(),
  type: z.enum(ADDITIONAL_PRODUCT_TYPES, {
    message: 'validation.invalidOption',
  }),
  is_universal: z.boolean().optional(),
  product_ids: z.array(z.number().int()).optional(),
});

export type StoreAdditionalProductPayload = z.infer<
  typeof StoreAdditionalProductSchema
>;
export const UpdateAdditionalProductSchema =
  StoreAdditionalProductSchema.partial();
export type UpdateAdditionalProductPayload = z.infer<
  typeof UpdateAdditionalProductSchema
>;

export const additionalProductTranslations = _([
  'catalog.additionalProducts.title',
  'catalog.additionalProducts.add',
  'catalog.additionalProducts.edit',
  'catalog.additionalProducts.deleteConfirmHeader',
  'catalog.additionalProducts.deleteConfirmMessage',
  'catalog.additionalProducts.created',
  'catalog.additionalProducts.updated',
  'catalog.additionalProducts.deleted',
  'catalog.additionalProducts.notFound',
  'catalog.additionalProducts.loadError',
  'catalog.additionalProducts.createError',
  'catalog.additionalProducts.updateError',
  'catalog.additionalProducts.deleteError',
  'catalog.additionalProducts.empty',
  'catalog.additionalProducts.dashboardDescription',
  'catalog.additionalProducts.dashboardButton',
  'catalog.additionalProducts.fields.title',
  'catalog.additionalProducts.fields.description',
  'catalog.additionalProducts.fields.type',
  'catalog.additionalProducts.fields.typePlaceholder',
  'catalog.additionalProducts.types.fixed',
  'catalog.additionalProducts.types.multiply',
  'catalog.additionalProducts.types.multiply_reduced_one',
]);
